export default {"src":"/_next/static/media/community-spotlight-icon.df0aa539.svg","height":32,"width":33};